import InfiniteScrollSectionOne from './InfiniteScrollFirst';
import InfiniteScrollSectionThree from './InfiniteScrollThree';
import InfiniteScrollSectionTwo from './InfiniteScrollTwo';

function InfiniteScrollSection() {
  return (
    <div className="bg-black-variant flex flex-col gap-6 py-6 md:gap-11 md:py-11">
      <InfiniteScrollSectionOne />
      <InfiniteScrollSectionTwo />
      <InfiniteScrollSectionThree />
    </div>
  );
}

export default InfiniteScrollSection;
